import React from 'react'
import Hjemmesidebillede from '../assets/HjemmesideBillede-Photoroom.png'
import VillingerMobile from '../assets/VILLINGER2BlueIconforMobile.png'
import {MdOutlineKeyboardArrowRight} from 'react-icons/md'
import { Link } from 'react-scroll'
import { motion } from 'framer-motion';

const Forside = () => {
  return (
    <div name="Forside" className='h-screen w-full bg-gradient-to-b from-white via-white to-white'>
      <div className='max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row'>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className='flex flex-col items-center md:items-start justify-center h-full text-center md:text-left'
        >
          {/* Mobile Image */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 1.2 }}
            className="md:hidden mb-8 flex justify-center w-full"
          >
            <img src={VillingerMobile} alt="Villinger Logo" className='rounded-2xl w-1/2' />
          </motion.div>

          <motion.h2 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5, duration: 1.2 }}
            className='text-4xl sm:text-7xl font-bold text-black'
          >
            I am your Finance Partner
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2.0, duration: 1.2 }}
            className='text-black py-4 max-w-md'
          >
            I am your Finance Partner specializing in operational finance. I help you get a clear overview of the business, find the growth opportunities, and implement them.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 4.5, duration: 1.2 }}
          >
            <Link to='Services' smooth duration={500} className='group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md cursor-pointer' style={{ background: 'rgb(1, 50, 32)' }}>
              What I do
              <span className='group-hover:rotate-90 duration-300'>
                <MdOutlineKeyboardArrowRight size={25} className='ml-1' />
              </span>
            </Link>
          </motion.div>

          
        </motion.div>

        {/* Desktop Image */}
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 4.5, duration: 1.2 }}
          className="hidden md:block" // Hide on small screens, show on md and up
        >
          <img src={Hjemmesidebillede} alt="My Profile" className='rounded-2xl mx-auto w-2/3 md:w-full' />
        </motion.div>
      </div>
    </div>
  )
}

export default Forside